import axios from 'axios';
import { base_url } from './api-config'; 

const getHeaders = (operation: string, key_id?: number) => {
    let header: any = {
        "Content-Type": "application/json",
        "operation": operation
    }
    if (key_id && key_id != undefined && key_id != null) {
        header["key-id"] = key_id
    }

    return { 
        headers: header
    }
}

/*
 * A failed call is a failed call.
 *
 * This module used to swallow every error and return an empty list, so a
 * Backend outage was indistinguishable from a shop with no records --
 * the same defect found in the Consignment, Expense and Report clients
 * during the Phase 7C-6C sweep. Errors carrying a response are passed
 * through untouched, because callers read `e.response.data.message` and
 * the auth interceptor needs to see the 401; only a failure with no
 * response at all (offline, DNS, timeout) becomes a plain Error.
 */

export const api_member_group = async (operation: string, body: any, key_id?: number) => {
    let result: any = [];

    await axios.post(`${base_url}/api/v1/member/group`, JSON.stringify(body), getHeaders(operation, key_id))
        .then(res => {
            if (res && res.status == 200) {
                result = res.data;
            }
        })

    return result;
}

export const api_member = async (operation: string, body: any, key_id?: number) => {
    let result: any = [];

    await axios.post(`${base_url}/api/v1/member`, JSON.stringify(body), getHeaders(operation, key_id))
        .then(res => {
            if (res && res.status == 200) {
                result = res.data;
            }
        })

    return result;
}